import InputEmailWithDomains from '@portalterreno/nextjs-client/components/InputEmailWithDomains';
import InputName from '@portalterreno/nextjs-client/components/InputName';
import InputPhone from '@portalterreno/nextjs-client/components/InputPhone';
import Typography from '@portalterreno/react-ui-core/Typography';
import { useTranslation } from 'next-i18next';
import React from 'react';

import TermsAndConditions from '../../../TermsAndConditions';
import ReCaptchaTAC from '../../../TermsAndConditions/ReCaptchaTAC';
import TACDiv from '../../../TermsAndConditions/TACDiv';
import StyledSellerInformation, {
  StyledSellerInformationProps
} from './StyledSellerInformation';

export type ShowPhoneFormValuesProps = StyledSellerInformationProps;

const ShowPhoneFormValues: React.FC<ShowPhoneFormValuesProps> = ({
  sellerLogo,
  sellerName
}) => {
  const { t } = useTranslation('property');

  return (
    <React.Fragment>
      <Typography
        variant='body1'
        weight='light'
      >
        {t('showPhoneDescription')}
      </Typography>
      {sellerName && (
        <StyledSellerInformation
          sellerName={sellerName}
          sellerLogo={sellerLogo}
        />
      )}

      <InputName />
      <InputEmailWithDomains />
      <InputPhone />

      <TACDiv>
        <TermsAndConditions />
        <ReCaptchaTAC />
      </TACDiv>
    </React.Fragment>
  );
};

export default ShowPhoneFormValues;
